/* ─────────────────────────────────────────────────────────────────────────
   The one clock the whole homepage runs on.

   `s` is scroll through the pinned story measured in viewport heights, so a
   chapter that is 1.6 long takes 1.6 screens of scrolling. The DOM overlay
   and the WebGL stage both read these same ranges — change a number here and
   the copy and the 3D move together.
   ───────────────────────────────────────────────────────────────────────── */

export const CH = {
  hero:      [0.0, 1.0],
  idea:      [1.0, 2.8],
  build:     [2.8, 4.8],
  prototype: [4.8, 6.7],    // the print itself is three wheel scrolls (PRINT_PX in Stage.js)
  integrate: [6.7, 10.0],
  activate:  [10.0, 11.2],
  validate:  [11.2, 12.8],
  deploy:    [12.8, 14.6],
  ind0:      [14.6, 16.0],
  ind1:      [16.0, 17.4],
  ind2:      [17.4, 18.8],
  ind3:      [18.8, 20.2],
  caps:      [20.2, 22.6],
};
export const STORY_LEN = CH.caps[1];

/* The rail on the right edge. */
export const RAIL = [
  ['hero', 'Blueprint'], ['idea', 'Idea'], ['build', 'Build'], ['prototype', 'Prototype'],
  ['integrate', 'Integrate'], ['activate', 'Activate'], ['validate', 'Validate'],
  ['deploy', 'Deploy'], ['ind0', 'Healthcare'], ['ind1', 'Industrial IoT'],
  ['ind2', 'Education'], ['ind3', 'Utilities'], ['caps', 'Capabilities'],
];

export const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
export const lerp = (a, b, t) => a + (b - a) * t;
export const invLerp = (a, b, v) => clamp((v - a) / (b - a));
export const smooth = t => t * t * (3 - 2 * t);
export const easeInOut = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
export const easeOut = t => 1 - Math.pow(1 - t, 3);
export const easeIn = t => t * t * t;

/* Local 0..1 progress through chapter `k`, optionally only a sub-window of it. */
export function local(s, k, a = 0, b = 1) {
  const [s0, s1] = CH[k];
  return invLerp(s0 + (s1 - s0) * a, s0 + (s1 - s0) * b, s);
}

/* Fade-in / hold / fade-out envelope across [s0, s1] with `f` of each end spent fading. */
export function envelope(s, s0, s1, fIn = 0.35, fOut = 0.35) {
  const w = s1 - s0;
  // each panel is fully gone before the next arrives, so titles never overlap
  // (windows are built start < end whatever fIn/fOut are, so a short fade can't invert)
  const a = invLerp(s0 + w * 0.03, s0 + w * (0.03 + fIn * 0.42), s);
  const b = 1 - invLerp(s1 - w * (0.03 + fOut * 0.42), s1 - w * 0.03, s);
  return clamp(Math.min(a, b));
}

export function chapterAt(s) {
  for (const [k] of RAIL) { const [a, b] = CH[k]; if (s >= a && s < b) return k; }
  return s < 0 ? 'hero' : 'caps';
}
